import {
  GET_CONTINGENCIES_BUYER_LIST,
  GET_CONTINGENCIES_BUYER_LIST_ERROR,
  GET_CONTINGENCIES_BUYER_LIST_SUCCESS
} from './ContingenciesBuyersListSection.actions'

const buyersListState = {
  data: [],
  error: null,
  loading: false
}

/**
 * The contingenciesBuyersList's reducer.
 */
const contingenciesBuyersListReducer = (state = buyersListState, { payload, type }) => {
  switch (type) {
    case GET_CONTINGENCIES_BUYER_LIST: {
      return { ...state, loading: true }
    }
    case GET_CONTINGENCIES_BUYER_LIST_ERROR: {
      return { ...state, error: payload.error, loading: false }
    }
    case GET_CONTINGENCIES_BUYER_LIST_SUCCESS: {
      return { ...state, data: payload.buyers, loading: false }
    }
    default: {
      return state
    }
  }
}

export default contingenciesBuyersListReducer
